<template>
	<!-- 付费阅读-->
	<div class="aboutYjBox">
		<div class="fixed_top">
			<span>{{vipBooks_name}}</span>
			<span>第{{vipNumber}}章&nbsp;{{vipTitle}}</span>
		</div>
		<div class="vipread_txt">
			<h4>第{{vipNumber}}章&nbsp;{{vipTitle}}</h4>
			<p>本章为VIP章节，请支持正版阅读</p>
		</div>
		<div class="purchaseSection">
			<p>余额<span class="txt_color">{{vipUser_money}}</span>云锦币</p>
			<button @click.stop="subscribechapter(index)" 
				:class="actvie_btn1 == index ? 'activebgc' : ''" 
				:disabled="index == 0 && tabSubscribechapter"
				v-for="(item,index) in btn_list_val">
				<span v-if="index == 0 ? true : false">{{ tabSubscribechapter ? '正在订阅……' : (item.a + '（' + vip_cost + item.b + '）') }} </span>
				<span v-if="index == 1 ? true : false">{{item}}</span>
			</button>
			<div>
				<van-checkbox-group v-model="purchase" direction="horizontal" checked-color="#ff4081">
					<van-checkbox name="1"><span :style="{color:fontColor}">购买后下载</span></van-checkbox>
					<van-checkbox name="2"><span :style="{color:fontColor}">自动续订</span></van-checkbox>
				</van-checkbox-group>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	export default {
		// props: {
		//   titleInfo: {
		//     vipBooks_name: '',
		//     vipNumber: '',
		// 	vipTitle: '',
		// 	vip_cost: 0,
		// 	vipUser_money: 0,
		//   },
		// },
		props: {
			vipBooks_name: String,
			vipNumber: Number,
			vipTitle:String,
			vip_cost: Number,
			vipUser_money:String,
			btn_list_val:Array,
			tabSubscribechapter: Boolean
		},
		data() {
			return {
				balance: 0, //余额
				yunjinCoiny: 0, //云锦币
				actvie_btn1: 0,
				purchase: ['1'],
				// btn_list: [{
				// 		a: '订阅本章',
				// 		b: '云锦币'
				// 	},
				// 	'批量订阅'
				// ],
				readVipid: '',
				readId: '',
				// vipBooks_name: '', //vip 书本名称
				// vipNumber: 0, //vip 章节数
				// vipTitle: '', //vip 章节标题
				// vip_cost: 0, // vip 购买章节数量
				// vipUser_money: '', // 用户余额
				background:'',
				fontColor:'',
				
			}
		},
		created() {
			let localShelfSet = JSON.parse(localStorage.getItem('userSet')) || null;
			if (localShelfSet != null) {
				this.background = localShelfSet.background;
				this.fontColor = localShelfSet.color;
			}
		},
		methods: {
			//订阅本章
			subscribechapter(activeIndex) {
				this.actvie_btn1 = activeIndex;
				this.$emit('subscribeChapter',activeIndex)
				// if (this.actvie_btn1 == 0) {
				// 	// this.$router.push('/bookcity')
				// 	Toast('云锦币不足')
				// 	// this.$emit('yunjincoinyczfn01')
				// } else if (this.actvie_btn1 == 1) {
				// 	// this.$emit('yunjincoinyczfn02')
				// 	// this.$router.push({
				// 	// 	path: '/pldy',
				// 	// 	query: {
				// 	// 		readId: this.readId
				// 	// 	}
				// 	// })
				// }
			},
		},
	}
</script>

<style lang="less" scoped>
	.aboutYjBox {
		position: fixed;
		top: 0;
		left: 0;
		background: #f4f5e2;
    	color: #333332;
		width: 100vw;
		height: 100vh;
		overflow-y: scroll;

		.fixed_top {
			span {
				position: fixed;
				top: 20px;
			}

			span:first-of-type {
				left: 16px;
			}

			span:last-of-type {
				right: 16px;
			}
		}

		.vipread_txt {
			text-align: center;
			padding-bottom: 25vh;
			h4 {
				padding-top: 80px;
				/*px*/
				font-size: 30px;
				/*px*/
				text-align: left;
				padding-left: 16px;
			}

			p {
				padding-top: 10vh;
				font-size: 30px;
				/*px*/
				line-height: 50px;/*px*/
			}
		}

		.purchaseSection {
			font-size: 30px;/*px*/
			position: fixed;
			bottom: 10%;
			left: 0;
			.txt_color {
				color: #ff4081;
			}

			padding-left: 75px;
			padding-right: 75px;
			text-align: center;

			p {
				text-align: left;
				line-height: 80px;/*px*/
			}

			button {
				width: calc(100vw - 150px);
				line-height: 80px;
				border: 1px solid #ff4081;
				/*no*/
				background-color: #fff;
				color: #ff4081;
				margin-bottom: 30px;
				border-radius: 80px;

				&:disabled {
					background-color: #f7f7f7;
					color: #c8c9cc;
					border-color: #e5e5e5;
				}
			}

			.activebgc {
				background-color: #ff4081;
				color: #fff;
			}

			.van-checkbox-group--horizontal {
				justify-content: space-between;

				/deep/.van-checkbox__icon .van-icon {
					border-color: #ff4081 !important;
					background-color: #fff;
				}

				/deep/.van-checkbox__icon--checked .van-icon {
					color: transparent !important;

					&::before {
						display: none;
					}
				}
			}
		}
	}
</style>
